// @ts-nocheck

import React, { useCallback } from 'react';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { actions as loginActionCreators } from '../../actions/login';
import useMergeProps from '../../hooks/useMergeProps';
import { RoutePatterns } from '../../types/routes';

import LegalWrapper from './LegalWrapper';
import selectLegalWrapperProps from './LegalWrapper.selector';

const useMatchRoute = () => {
  const match = useRouteMatch({ path: RoutePatterns.MATCH, exact: true });
  const matchBasketItem = useRouteMatch({ path: RoutePatterns.MATCH_AND_BASKETITEM, exact: true });
  return match || matchBasketItem;
};

type LegalWrapperContainerPropsType = {
  children: React.ReactNode;
};

const LegalWrapperContainer = (ownProps: LegalWrapperContainerPropsType) => {
  const dispatch = useDispatch();
  const routeMatch = useMatchRoute();
  const { params: { matchId } = {} } = routeMatch ?? {};

  const selectorProps = useMemo(() => ({ matchId: parseInt(matchId, 10) }), [matchId]);
  const { jwt, sessionId, ...selectedProps } = useSelector((state) => selectLegalWrapperProps(state, selectorProps));

  const handlePanicButtonPress = useCallback(() => {
    dispatch(loginActionCreators.banDeUser({ jwt, sessionId }));
  }, [dispatch, jwt, sessionId]);

  const otherProps = useMemo(
    () => ({
      handlePanicButtonPress,
    }),
    [handlePanicButtonPress],
  );

  const enhancedProps = useMergeProps({ ownProps, otherProps, selectedProps });

  return <LegalWrapper {...enhancedProps} />;
};

export default LegalWrapperContainer;
